// extracted by mini-css-extract-plugin
module.exports = {"AboutPage__backgroundGradient":"AboutPage_AboutPage__backgroundGradient__4JYvj"};